import { get, post, patch } from "../../xhr/api";

export const previewAndDownloadDeclarationFile = (url) =>
  get(`${url}`, { responseType: "blob" }, true);
